import { isEmpty } from 'lodash';
import React from 'react';
import ContentContainer from '~/src/components/ContentContainer';
import { imgOteLogoWhiteSvg } from '~/src/images';
import { positions } from '~/src/lib';
import styles from '~/src/lib/styles.json';
import { OtePlayer } from '~/src/models/OtePlayer';
import { OteTeam } from '~/src/models/OteTeam';
import Picture from '~/src/overtime-lib/src/www/components/Picture';
import { colorFromInt } from '~/src/overtime-lib/src/www/lib';
import './Profile.scss';

const Profile = ({ player, team }: { player: OtePlayer; team: OteTeam }) => {
	const birthdate = new Date(player.birthdate);
	const now = new Date();
	const ageYears = now.getFullYear() - birthdate.getFullYear();
	const age =
		now.getMonth() > birthdate.getMonth()
			? ageYears
			: now.getMonth() === birthdate.getMonth() && now.getDate() >= birthdate.getDate()
				? ageYears
				: ageYears - 1;

	const teamColor = { color: team?.is_current ? colorFromInt(team.secondary_foreground_color) : styles.COLOR.WHITE };
	return (
		<div
			className="PlayerProfile"
			style={{ backgroundColor: team?.is_current ? colorFromInt(team.secondary_color) : styles.COLOR.BRAND_PRIMARY }}
		>
			<ContentContainer>
				<div className="ProfileContainer">
					<div
						style={{
							backgroundImage: `linear-gradient(180deg, ${colorFromInt(
								team?.primary_color ?? 0xaaaaaa,
							)} 0%, ${colorFromInt(team?.primary_color ?? 0xaaaaaa)} 20% , white)`,
						}}
						className={['ImageContainer', !player.image_path ? 'Placeholder' : null].filter(Boolean).join(' ')}
					>
						{player.image_path ? (
							<Picture src={`https://images.overtime.tv/${player.image_path}?quality=60`} alt={player.full_name} />
						) : (
							<img alt={player.full_name} src={imgOteLogoWhiteSvg} />
						)}
					</div>
					<div>
						<h1 style={teamColor}>{player.full_name}</h1>
						<div className="Position">{positions[player.position]}</div>
						<div className="Rule" style={{ backgroundColor: teamColor.color }} />
						<div className="Vitals">
							<div>
								<label style={teamColor}>Height</label>
								<div>{player.height > 0 ? `${Math.floor(player.height / 12)}' ${player.height % 12}"` : 'N/A'}</div>
							</div>

							<div>
								<label style={teamColor}>Age</label>
								<div>{player.birthdate ? age : 'N/A'}</div>
							</div>
							<div>
								<label style={teamColor}>Weight</label>
								<div>{player.weight ? `${player.weight} lbs` : 'N/A'}</div>
							</div>
							<div>
								<label style={teamColor}>Grad Year</label>
								<div>{player.graduation_year ?? 'N/A'}</div>
							</div>
							{!isEmpty(player.hometown) ? (
								<div>
									<label style={teamColor}>Hometown</label>
									<div className="Hometown">{player.hometown}</div>
								</div>
							) : null}
						</div>
					</div>
				</div>
			</ContentContainer>
		</div>
	);
};

export default Profile;
